import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { AssignmentReportsGridPostParams } from 'common/models/page-models/reports/assignment-reports/assignment-grid-params';
import { AssignmentReportsModel } from 'common/models/page-models/reports/assignment-reports/assignment-report.data-model';
import { AssignmentChartsModel } from 'common/models/page-models/reports/assignment-reports/assignment-reports-charts.model';
import { AssignmentReportsListingModel } from 'common/models/page-models/reports/assignment-reports/assignment-reports-grid-model';


@Injectable({
  providedIn: 'root'
})
export class AssignmentReportsDataService extends GridDataService<AssignmentReportsListingModel, AssignmentReportsModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.fetchReportData, http, ss);
  }

  createInstance(): AssignmentReportsListingModel {
    return new AssignmentReportsListingModel();
  }

  getDeleteUrl() {
    return '';
  }

  override getGridParams(param): GridPostParams {
    return new AssignmentReportsGridPostParams();
  }

  override transformDataModel(data: any[], param: any) {
    super.transformDataModel(data, param);
     console.log(data,param);
     
    if (data.hasOwnProperty(param)) {
      data[param].forEach(element => {
        // const avgScore = new Headers('Average Score', 'avgScore', false, false, 'text');
        // const totalScoreInPercentage =
        // element.avgScore = element.avgScore === 0 ? '0' : element.avgScore;
        // element.totalScoreInPercentage = element.totalScoreInPercentage === 0 ? '0' : element.totalScoreInPercentage;
        element['notattended_Student'] = element.assignment.notattended_Student
        element.totalAssignmentAssigned = element.assignment.totalAssignmentAssigned
        // element.totalScoreInPercentage = element.totalSemScore
        element.totalScoreInPercentage = element.scoreTotal

        element.avgScore = element.assignment.avgScore ? element.assignment.avgScore : "0";
        element.attended_Student = element.assignment?.attended_Student ? element.assignment.attended_Student : "0";
      });
    } else {
      // console.log('No records found for given combination');
      this.ss.showError('No records found for given combination')
    }
    return data;
  }

  override modifyGridPostParams(queryParams) {
    let payload = this.getGridParams(queryParams);
    if (queryParams.transferData !== null) {
      payload['batch_search'] = queryParams.transferData.selectedBatch === null ? '' : queryParams.transferData.selectedBatch;
      payload['region_search'] = queryParams.transferData.selectedRegion === null ? '' : queryParams.transferData.selectedRegion;
      payload['branch_search'] = queryParams.transferData.selectedBranch === null ? '' : queryParams.transferData.selectedBranch;
      payload['state_search'] = queryParams.transferData.selectedState === null ? '' : queryParams.transferData.selectedState;
      payload['gender_search'] = queryParams.transferData.selectedGender === null ? '' : queryParams.transferData.selectedGender;
      payload['status_search'] = queryParams.transferData.selectedStatus === null ? '' : queryParams.transferData.selectedStatus;
      payload['location_search'] = queryParams.transferData.selectedLocation === null ? '' : queryParams.transferData.selectedLocation;
      payload['type_search'] = queryParams.transferData.selectedType === null ? '' : queryParams.transferData.selectedType;
      payload['cat_search'] = queryParams.transferData.selectedCategory === null ? '' : queryParams.transferData.selectedCategory;
      payload['attendence_search'] = queryParams.transferData.selectedAttended === null ? '' : queryParams.transferData.selectedAttended;
      payload['fromDate_search'] = queryParams.transferData.selectedFromDate === '' || queryParams.transferData.selectedFromDate === null ? '' : this.formatDateToYYYYMMDD(queryParams.transferData.selectedFromDate);
      payload['toDate_search'] = queryParams.transferData.selectedToDate === '' || queryParams.transferData.selectedToDate === null ? '' : this.formatDateToYYYYMMDD(queryParams.transferData.selectedToDate);
    }
    return payload;
  }

  private formatDateToYYYYMMDD(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  }

  override prepareChartsData(apiData) {
    const chartsModel = new AssignmentChartsModel();
    let attended = 0;
    let notAttended = 0;
    let assigned = 0;
    console.log(apiData);
    
    apiData.forEach((key) => {
      attended = attended + parseInt(key.attended_Student);
      notAttended = notAttended + parseInt(key.notattended_Student);
      assigned = assigned + parseInt(key.totalAssignmentAssigned);
    })

    console.log(apiData);
    

    chartsModel.studentStatusChart.options = {
      colors: ["#219c51", "#61d48e", "#fff", "#5f5ce9", "#abaae9"],
      chart: {
        height: 300,
        type: "bar",
      },
      title: {
        text: "Student Assignment Analysis",
      },
      xAxis: {
        categories: ["", "", "", "", "", ""],
        title: {
          text: null,
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: "",
          align: "high",
        },
        labels: {
          overflow: "justify",
        },
      },
      tooltip: {
        enabled: false,
        valueSuffix: "",
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
      },
      legend: {
        enabled: true,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: "Assignments Assigned",
          data: [assigned],
          color: "#0e6052",
        },
        {
          name: "Assignments Attended",
          data: [attended],
          color: "#01a185",
        },
        {
          name: "Assignments Not Attended",
          data: [notAttended],
          color: "#17d5b3",
        },
      ],
    };

    chartsModel.studentStatusChart.data = {
      continue: 'Assignments Assigned',
      continueColor: '#0e6052',
      disContinue: 'Assignments Attended',
      disContinueColor: '#01a185',
      complete: 'Assignments Not Attended',
      completeColor: '#17d5b3'
    }
    return chartsModel;
  }
}
